import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { GhUserProfileDto } from '../../api/generated/administration/models/gh-user-profile-dto';

export const UserActions = createActionGroup({
  source: 'User',
  events: {
    'Load Profile Requested': emptyProps(),
    'Load Profile Succeeded': props<{ profile: GhUserProfileDto; syncedAt: string }>(),
    'Load Profile Failed': props<{ error: string }>(),
    Reset: emptyProps(),
  },
});
